import type { TinaMarkdownContent } from 'tinacms/dist/rich-text';

//(.*)(?:<([^<>\s]+)\s{0,1}(.+)=[{"](.+)["}]\s{0,1}\/>)(.*)

export const toTinaMarkdown = (value: string): TinaMarkdownContent | any => {
    const parts = value.match(/[^<>]+/g);    

    return {
        type: 'root',
        children: parts ? parts.map(match => {
            
            if ( match.match(/CurrentYear/) ) {
                const [component, ...props] = match.split(/\s/g);
                
                const p: { [key: string]: string } = {};

                props.forEach(prop => {
                    const propParts = /([a-zA-Z]+)=[{"'](.+)['"}]/.exec(prop);
                    if ( propParts ) {
                        const [_, _prop, _value] = propParts;
                        p[_prop] = _value;
                    }
                });

                return {
                    type: 'mdxJsxFlowElement',
                    name: component,
                    props: p,
                    children: [{type: 'text', text: ''}]
                }
            }

            return {
                type: 'text',
                text: match || ''
            }
        }) : [{ type: 'text', text: '' }]
    }
};